class Trigger {
    static get instance () {
        if(!Trigger._instance) { Trigger._instance = new Trigger(); }
        return Trigger._instance;
    }
    
    constructor() {
        
    }
}

export default Trigger;
Trigger.instance;